var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOption(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0114 20.5C13.0857 20.5 14 19.6253 14 18.5488C14 17.4722 13.1086 16.5975 12.0114 16.5975C10.8914 16.5975 10 17.4498 10 18.5488C10 19.6253 10.8914 20.5 12.0114 20.5Z",
    fill: "#C5C5C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0114 13.9512C13.0857 13.9512 14 13.0765 14 12C14 10.9235 13.1086 10.0488 12.0114 10.0488C10.8914 10.0488 10 10.901 10 12C10 13.0765 10.8914 13.9512 12.0114 13.9512Z",
    fill: "#C5C5C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0114 7.40246C13.0857 7.40246 14 6.52777 14 5.45123C14 4.37469 13.1086 3.5 12.0114 3.5C10.8914 3.5 10 4.35226 10 5.45123C10 6.52777 10.8914 7.40246 12.0114 7.40246Z",
    fill: "#C5C5C5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOption);
export default __webpack_public_path__ + "static/media/Option.946d7f6e9f0abace82f0f5553365f724.svg";
export { ForwardRef as ReactComponent };